import { isDev } from 'src/environmentVariables/EnvironmentVariables';
import { getOracleUrl } from 'src/utils/oracle';
import UIHelpTextLink from '../UIHelpTextLink';
import { MarketData } from 'src/hooks/useMarketInfoDisplayData';
import { OracleSource, PublicKey } from '@velocity-exchange/sdk';
import { isPythOracle, isPullOracle } from '@velocity-exchange/common';

export const MarketOracleInfo = ({
	marketData,
	oracleSource,
	selectedMarketBaseAssetSymbol,
	oracle,
	tenSlotOracleDelayText,
	confidenceIntervalTooLargeText,
}: {
	marketData: MarketData;
	oracleSource: OracleSource;
	selectedMarketBaseAssetSymbol: string | undefined;
	oracle: PublicKey;
	tenSlotOracleDelayText: string;
	confidenceIntervalTooLargeText: string;
}) => {
	return (
		<>
			Oracle provided by
			<a
				href={getOracleUrl(
					oracleSource,
					selectedMarketBaseAssetSymbol ?? '',
					oracle?.toString(),
					isDev()
				)}
				target="_blank"
				rel="noreferrer"
			>
				{' '}
				{isPythOracle(oracleSource) ? 'Pyth' : 'Switchboard'}
			</a>
			.
			<br />
			<MarketOracleInfoText
				marketData={marketData}
				oracleSource={oracleSource}
				tenSlotOracleDelayText={tenSlotOracleDelayText}
				confidenceIntervalTooLargeText={confidenceIntervalTooLargeText}
			/>
		</>
	);
};

const MarketOracleInfoText = ({
	marketData,
	oracleSource,
	tenSlotOracleDelayText,
	confidenceIntervalTooLargeText,
}: {
	marketData: MarketData;
	oracleSource: OracleSource;
	tenSlotOracleDelayText: string;
	confidenceIntervalTooLargeText: string;
}) => {
	const oraclePrice = marketData.mmOraclePrice ?? marketData.oraclePrice;
	const oracleErr = marketData.mmOracleErr ?? marketData.oracleErr;
	const oracleSlotDelay =
		marketData.lastMmOracleSlotDelay !== undefined
			? marketData.lastMmOracleSlotDelay
			: marketData.lastOracleSlotDelay;

	if (isPullOracle(oracleSource)) {
		return <>Last pull: {Math.max(oracleSlotDelay, 0)} slots ago</>;
	}

	return (
		<>
			{oracleSlotDelay >= 10 ? (
				<>
					{'⚠️ Oracle Status: Delayed/Stale Data (Updated ' +
						`${oracleSlotDelay}` +
						' slots ago)'}
					<br /> <br />
					{tenSlotOracleDelayText + ' The order matching is still available.'}
					<UIHelpTextLink
						href="https://docs.drift.trade/trading/oracles"
						text="More Info..."
						className="mt-2"
					/>
				</>
			) : parseFloat(oracleErr) / oraclePrice >= 0.02 ? (
				<>
					{'⚠️ Oracle Status: Confidence Interval Too Large (Updated ' +
						`${(parseFloat(oracleErr) / oraclePrice) * 100}` +
						'% )'}
					<br /> <br />
					{confidenceIntervalTooLargeText +
						' The order matching is still available.'}
					<UIHelpTextLink
						href="https://docs.drift.trade/trading/oracles"
						text="More Info..."
						className="mt-2"
					/>
				</>
			) : (
				''
			)}
		</>
	);
};
